import React, { Component } from 'react';
import "./SuccessTabs.css";

class SuccessTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    addValues=(values)=>{
        let valuess = []
        if(values.length>0){
            values.map(item=>{
                // if(item.important){
                    valuess.push(<p key={item.name}>{item.name}</p>)
                // }
            })
        }
        return valuess
    }
    addTabs = (data) => {
        let tabs = []
        if (data.length > 0) {
            data.map((item, key) => {
                tabs.push(<li className="nav-item" key={item.groupName} onClick={()=>this.props.onTabChange(key)}>
                    <a data-toggle="tab" className={key == this.props.tabStep ? "nav-link active" : "nav-link"} href={`#${item.groupName}`} aria-controls={`${item.groupName}`} aria-selected="false">{item.groupName}</a>
                </li>)
            })
        }
        return tabs
    }
    addTabContents = (data) => {
        let content = [];
        if (data.length > 0) {
            data.map((item, key) => {
                content.push(
                    <div id={item.groupName} className={key === this.props.tabStep ? "tab-pane fade tabContentdiv show active" : "tab-pane fade tabContentdiv"} role="tabpanel" key={key}>
                        {/* <div className="container"> */}
                            <div className="row">
                                <div className="col-md-12">
                                    {/* <div className="container"> */}
                                        <div className="row">
                                            <div className="col-md-2">
                                                <div style={{ display: "flex", height: "100%" }}><span className="resultsSpan">Values</span></div>
                                            </div>
                                            <div className="col-md-10">
                                                <div className="resultsDiv">
                                                    {item.values.length>0 && this.addValues(item.values)}
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div style={{ display: "flex", height: "100%" }}><span className="resultsSpan">Benefits</span></div>
                                            </div>
                                            <div className="col-md-10">
                                                <div className="resultsDiv">
                                                        {item.benefits.length>0 && this.addValues(item.benefits)}
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div style={{ display: "flex", height: "100%" }}><span className="resultsSpan">Attributes</span></div>
                                            </div>
                                            <div className="col-md-10">
                                                <div className="resultsDiv">
                                                    {item.attributes.length>0 && this.addValues(item.attributes)}
                                                </div>
                                            </div>
                                        </div>
                                    {/* </div> */}
                                </div>
                            </div>
                        {/* </div> */}
                    </div>
                )
            })
        }
        return content
    }
    render() {
        return (
            <div className="col-md-12" id="successTabsforPdf">
              <div className="card">
                <div className="card-header">
                  <h5 style={{marginBottom: "0px"}}>Results</h5>
                </div>
                <div className="card-body">
                  <ul className="nav nav-tabs successTabs" role="tablist" id="myTab">
                      {this.props.benefits.benefitsLadderFetched && this.addTabs(this.props.benefits.benefitsLadderData.Items[0].data)}
                  </ul>
                  <div className="tab-content benefitsTabcontent" id="myTabContent" >
                      {this.props.benefits.benefitsLadderFetched &&  this.addTabContents(this.props.benefits.benefitsLadderData.Items[0].data)}
                  </div>
                </div>
              </div>
            </div>
        )
    }
}

export default (SuccessTabs);



// WEBPACK FOOTER //
// ./src/components/BenefitsLadder/BenefitsLadderSuccess/SuccessTabs/SuccessTabs.jsx